import React from "react";
import { FaInstagram } from "react-icons/fa";

import ChannelConnectCard from "../ChannelConnect/ChannelConnectCard";

/**
 * Instagram messaging runs on the Facebook graph: an Instagram Business account
 * is reached through the Facebook Page it is linked to, so the dialog the user
 * sees is Facebook's. storak-plus then reads the accounts off the same stored
 * long-lived token (see FacebookTrait::getInstagramAccounts).
 */
const instagram = {
  name: "Instagram",
  // Sent with the token so the server knows which channel was connected.
  key: "instagram",
  title: "Connect Instagram",
  subtitle: "Let your AI assistant answer Instagram DMs around the clock.",
  logo: FaInstagram,
  // Instagram's own mark colours, warm end through to the violet.
  gradient:
    "linear(135deg, #F9CE34 0%, #EE2A7B 45%, #B02EAD 75%, #6228D7 100%)",
  markColor: "#C13584",
  accentColor: "#C13584",
  storePath: "/admin/bots/instagram",
  storageKeys: { user: "igUser", connected: "igAccountConnected" },
  scope: [
    "public_profile",
    // Instagram DMs are delivered through the linked Page's webhook
    // subscription, and Meta gates the `messages` and `messaging_postbacks`
    // fields of that subscription behind pages_messaging. Without it the
    // connect flow succeeds, the account lists, and no DM ever arrives.
    "pages_messaging",
    "pages_show_list",
    "pages_manage_metadata",
    "business_management",
    "instagram_basic",
    "instagram_manage_messages",
  ].join(","),
  /** Without these the account can be listed but never messaged. */
  requiredScopes: [
    "instagram_basic",
    "instagram_manage_messages",
    "pages_messaging",
  ],
  capabilities: [
    "Show a persistent menu in every Instagram conversation",
    "Answer buyers automatically with your AI assistant",
    "Let buyers browse and order without leaving the chat",
  ],
  note:
    "Your Instagram account has to be a Business or Creator account and linked to a Facebook Page — that link is what makes messaging possible.",
};

const ConnectToInstagram = () => <ChannelConnectCard channel={instagram} />;

export default ConnectToInstagram;
